import { Eye, Sparkles, Loader2 } from "lucide-react";

// Renders the "Enhance Transcript" cell for a call row.
// getRecordingUrl lets each source (ghl/kixie) resolve its own recording field.
export default function AiColumn({ call, source, generating, onView, onGenerate, getRecordingUrl }) {
  const hasAi = call.ai_analysis_id != null;
  const isGenerating = generating[call.id] || false;

  const recordingUrl = getRecordingUrl ? getRecordingUrl(call) : call.recording_url;
  const hasRecording = recordingUrl && recordingUrl.trim() !== "";

  if (hasAi) {
    return (
      <button onClick={() => onView(call, source)} className="flex items-center gap-1 text-xs bg-blue-50 text-blue-600 hover:bg-blue-100 px-2 py-1 rounded transition">
        <Eye size={14} />
        View
      </button>
    );
  }

  return (
    <button onClick={() => hasRecording && onGenerate(call.id, source)} disabled={!hasRecording || isGenerating} className={`flex items-center gap-1 text-xs px-2 py-1 rounded transition ${!hasRecording ? "bg-gray-100 text-gray-400 cursor-not-allowed" : "bg-sky-400 text-white hover:bg-sky-500 disabled:bg-sky-200 disabled:cursor-wait"}`} title={!hasRecording ? "Recording not available" : ""}>
      {isGenerating ? (
        <>
          <Loader2 size={14} className="animate-spin" />
          Generating...
        </>
      ) : (
        <>
          <Sparkles size={14} />
          Generate
        </>
      )}
    </button>
  );
}
